import Vue from 'vue';
export default {
  inject: ['setUniqueId'],
  data() {
    return {};
  },
  methods: {
    getPatientDoctorDetailActiveInfoFunction: function (patientId, missionPhoneId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getPatientDoctorDetailActiveInfo', {
          patientId: patientId,
          missionPhoneId: missionPhoneId,
        })
        .then(() => {
          if (this.$store.state.patientDoctorDetailModule.successFlag) {
            this.patientDoctorOrders = [];
            this.patientDoctorActions = [];
            this.doctorNote = '';
            this.chiefComplaintSearch = '';
            this.tempSelectedResult = '';
            this.selectedResult = null;
            let temp = this.$store.state.patientDoctorDetailModule.activeDetail;
            if (temp) {
              this.noteText = temp.note;
              this.selectedChiefComplaint = temp.diagnosis;
              for (let i = 0; i < temp.patientDoctorOrders.length; i++) {
                let standById = null;
                let standByTitle = '';
                if (temp.patientDoctorOrders[i].isStandby == true) {
                  standByTitle = 'استفاده شود';
                  standById = 1;
                } else {
                  standByTitle = 'آماده استفاده';
                  standById = 2;
                }
                this.patientDoctorOrders.push({
                  drugGroupId:
                    temp.patientDoctorOrders[i].drug && temp.patientDoctorOrders[i].drug.drugGroup
                      ? temp.patientDoctorOrders[i].drug.drugGroup.id
                      : null,
                  drugGroupTitle:
                    temp.patientDoctorOrders[i].drug && temp.patientDoctorOrders[i].drug.drugGroup
                      ? temp.patientDoctorOrders[i].drug.drugGroup.title
                      : '-',
                  drugId: temp.patientDoctorOrders[i].drug
                    ? temp.patientDoctorOrders[i].drug.id
                    : null,
                  drugtitle: temp.patientDoctorOrders[i].drug
                    ? temp.patientDoctorOrders[i].drug.title
                    : '-',
                  orderTypeId: temp.patientDoctorOrders[i].drugOrderType
                    ? temp.patientDoctorOrders[i].drugOrderType.id
                    : null,
                  orderTypeTitle: temp.patientDoctorOrders[i].drugOrderType
                    ? temp.patientDoctorOrders[i].drugOrderType.title
                    : null,
                  drugCount: temp.patientDoctorOrders[i].dosage,
                  standById: standById,
                  standByTitle: standByTitle,
                  showDetail: false,
                  id: i + 1,
                });
              }
              for (let i = 0; i < temp.patientDoctorActions.length; i++) {
                this.patientDoctorActions.push(temp.patientDoctorActions[i].title);
              }
              if (
                temp.result == 'قطع حین مکالمه' ||
                temp.result == 'توصیه به مراجعه' ||
                temp.result == 'نامشخص'
              ) {
                this.tempSelectedResult = 'other';
                this.selectedResult = temp.result;
              } else if (
                temp.result == '10-33' ||
                temp.result == '10-99' ||
                temp.result == '10-96'
              ) {
                this.tempSelectedResult = 'deliver';
                this.selectedResult = temp.result;
              } else if (
                temp.result == '10-35' ||
                temp.result == '10-19' ||
                temp.result == '10-29'
              ) {
                this.tempSelectedResult = 'notDeliver';
                this.selectedResult = temp.result;
              }
            } else {
              this.patientDoctorOrders = [];
              this.patientDoctorActions = [];
            }
            if (this.load.val) {
              this.load.val = false;
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.patientDoctorDetailModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getPatientDoctorDetailActiveInfoFunction(patientId, missionPhoneId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    addPatientDoctorDetailFunction: function (onSuccess) {
      if (this.selectedResult == null || this.selectedResult == undefined) {
        this.snackText = 'نتیجه نمی تواند خالی باشد';
        this.$refs.snackRef.snackModel = true;
        this.snackColor = '#FF5252';
        this.snakIcon = 'mdi-information';
        this.disabelConfirm = false;
        return;
      }
      let currentDate = Vue.moment().format('YYYY-MM-DDTHH:mm:ss');
      this.endDate = currentDate;
      const uniqueId = this.$root.$refs.Home.uniqueId;
      let data = {
        startDate: this.startDate,
        endDate: this.endDate,
        diagnosis: this.selectedChiefComplaint,
        result: this.selectedResult,
        note: this.noteText,
        missionPhoneId: this.missionPhoneId,
        patientId: this.patientId,
        patientDoctorOrders: [],
        patientDoctorActions: [],
        uniqueId,
      };
      for (let i = 0; i < this.patientDoctorOrders.length; i++) {
        let isStandby = true;
        if (this.patientDoctorOrders[i].standById == 1) {
          isStandby = false;
        }
        data.patientDoctorOrders.push({
          drugId: this.patientDoctorOrders[i].drugId,
          drugOrderTypeId: this.patientDoctorOrders[i].orderTypeId,
          dosage: parseFloat(this.patientDoctorOrders[i].drugCount),
          isStandby: isStandby,
        });
      }
      data.patientDoctorActions = this.patientDoctorActions?.map((itemTitle) => ({
        title: itemTitle,
      }));

      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addPatientDoctorDetail', data).then(() => {
        if (this.$store.state.patientDoctorDetailModule.successFlag) {
          this.snackText = '  با موفقیت ثبت شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          this.setUniqueId?.();

          if (this.load.val) {
            this.load.val = false;
          }
          onSuccess?.();
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientDoctorDetailModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addPatientDoctorDetailFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllPatientDoctorDetailFunction: function (missionPhoneId) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllPatientDoctorDetail', missionPhoneId).then(() => {
        if (this.$store.state.patientDoctorDetailModule.successFlag) {
          let data = this.$store.state.patientDoctorDetailModule.allDoctorOrders;
          this.readyDoctorData(data);
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.patientDoctorDetailModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllPatientDoctorDetailFunction(missionPhoneId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
  },
};
